import { Injectable } from '@angular/core';
import { concat, Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';

import { DictionaryApiRepository } from '../repositories/dictionary-api.repository';
import { DictionaryCacheRepository } from '../repositories/dictionary-cache.repository';
import { DictionaryInterface } from '../data';
import { Transaction } from '../transaction/transaction';

@Injectable()
export class DictionaryProvider {
    constructor(private dictionaryApiRepository: DictionaryApiRepository, private dictionaryCacheRepository: DictionaryCacheRepository) {}

    find(): Observable<Transaction<DictionaryInterface[]>> {
        return concat(
            this.dictionaryCacheRepository.load(),
            this.dictionaryApiRepository.load().pipe(
                tap((transaction) => {
                    if (transaction.isSuccess) {
                        this.dictionaryCacheRepository.save(transaction.data).subscribe();
                    }
                })
            )
        ).pipe(first());
    }
}
